import React, { useState } from "react";
import axios from "axios";
import { setWithExpiry, getWithExpiry } from "Helpers/index";
import { isEmpty } from "lodash";

const authRefreshJwt = async (noRedirect?: boolean) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/auth/jwt/refresh`;
  const session = getWithExpiry(process.env.APP_SESSION);

  try {
    const response = await axios({
      method: "POST",
      url: url,
      data: { refreshToken: session.refreshToken },
    });

    let responseData = response.data;
    responseData = { ...session, ...responseData };

    // Replace accessToken and refreshToken
    setWithExpiry(process.env.APP_SESSION, responseData);
    return true;
  } catch (err) {
    const item = getWithExpiry(process.env.APP_SESSION);

    if (!isEmpty(item)) {
      return true;
    } else {
      localStorage.removeItem(process.env.APP_SESSION);
      if (window && !noRedirect) window.location.href = window.location.href; // Force refresh client browser
      return false;
    }
  }
};

const useRefreshToken = async (noRedirect?: boolean) => {
  return await authRefreshJwt(noRedirect);
};

export default useRefreshToken;
